export class Promotion {
    id: number;
    code: string;
    expireDate: string;
    isSponsored: string;
    isUsed: string;
    percentage: string;
    userId: string;
    companyName: string;
    ModifiedBy: number;
    constructor(promotionData: any) {
      this.id = promotionData.id;
      this.code = promotionData.code;
      this.expireDate = promotionData.expireDate;
      this.isSponsored = promotionData.isSponsored;
      this.isUsed = promotionData.isUsed;
      this.percentage = promotionData.percentage;
      this.userId = promotionData.userId;
      this.companyName = promotionData.companyName;
      this.ModifiedBy = promotionData.ModifiedBy;
    }
  }
